// Template223: Kuala Lumpur - Día 2 Merdeka Square (Page6)
// Portada Merdeka + title + sticker, intro, Merdeka Square + SabiasQue, Mezquita Jamek + SabiasQue, River of Life, Cómo llegar.

import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import SabiasQue from "../SabiasQue";

const Template223 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;

	const headerText = page?.texts?.[0]?.content;
	const titleOverlay = page?.texts?.[1]?.content;
	const intro = page?.texts?.[2]?.content;
	const block1Title = page?.texts?.[3]?.content;
	const block1Body = page?.texts?.[4]?.content;
	const block2Title = page?.texts?.[5]?.content;
	const block2Body = page?.texts?.[6]?.content;
	const block3Title = page?.texts?.[7]?.content;
	const block3Body = page?.texts?.[8]?.content;
	const llegarTitle = page?.texts?.[9]?.content;
	const llegarList = page?.texts?.[10]?.content;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};

	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const portadaImage = getImageSrc("portada");
	const portadaSticker = getImageSrc("portada-sticker");
	const img2 = getImageSrc("img2");
	const img3 = getImageSrc("img3");
	const logoImage = getCanvasImageUrl("logo");

	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#2E7D5B";

	const estiloH3 = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 14,
		fontWeight: 700,
		textTransform: "uppercase",
		margin: 0,
	};

	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: 13,
		color: "#444",
		margin: 0,
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && !isSmallScreen && (
					<Box
						component="img"
						src={logoImage}
						alt="logo"
						sx={{
							width: 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			{portadaImage && (
				<Box data-block-id="image-0" sx={{ position: "relative" }}>
					<Box
						component="img"
						src={portadaImage}
						alt=""
						sx={{ width: "100%", height: 200, objectFit: "cover" }}
					/>
					{titleOverlay && (
						<Box
							component="h1"
							sx={{
								fontSize: 32,
								textAlign: "center",
								position: "absolute",
								bottom: 0,
								margin: 1.25,
								left: 20,
								color: "#fff",
								textShadow: "2px 2px 4px rgba(0,0,0,0.6)",
							}}
						>
							{titleOverlay}
						</Box>
					)}
					{portadaSticker && (
						<Box
							component="img"
							src={portadaSticker}
							alt=""
							sx={{ width: 90, position: "absolute", bottom: 50, left: 25 }}
						/>
					)}
				</Box>
			)}

			{intro && (
				<Box data-block-id="text-1" sx={{ padding: "10px 12px" }}>
					<Box component="p" sx={{ ...estiloP, color: "#333" }}>
						{intro}
					</Box>
				</Box>
			)}

			<Box
				data-block-id="text-2"
				sx={{
					padding: "0 12px",
					display: "flex",
					flexDirection: "column",
					gap: 1.5,
					marginTop: 1,
				}}
			>
				{/* Merdeka Square */}
				<Box
					data-block-id="text-3"
					sx={{
						display: "flex",
						gap: 2,
						position: "relative",
						marginTop: -0.5,
					}}
				>
					<Box sx={{ width: "100%" }}>
						{block1Title && (
							<Box component="h3" sx={estiloH3}>
								{block1Title}
							</Box>
						)}
						{block1Body && (
							<Box component="p" sx={estiloP}>
								{block1Body}
							</Box>
						)}
					</Box>
					{sabiasQue[0] && (
						<Box
							sx={{
								position: "absolute",
								top: isSmallScreen ? -10 : -20,
								right: "33%",
								zIndex: 30,
							}}
						>
							<SabiasQue
								icono={sabiasQue[0].icono}
								texto={sabiasQue[0].texto}
							/>
						</Box>
					)}
				</Box>

				{/* Mezquita Jamek */}
				<Box data-block-id="text-4" sx={{ display: "flex", gap: 2, position: "relative" }}>
					{img2 && (
						<Box
							component="img"
							src={img2}
							alt=""
							sx={{
								width: "40%",
								height: 100,
								borderRadius: "12px",
								objectFit: "cover",
							}}
						/>
					)}
					<Box sx={{ width: "60%" }}>
						{block2Title && (
							<Box component="h3" sx={estiloH3}>
								{block2Title}
							</Box>
						)}
						{block2Body && (
							<Box component="p" sx={estiloP}>
								{block2Body}
							</Box>
						)}
					</Box>
					{sabiasQue[1] && (
						<Box
							sx={{ position: "absolute", top: 10, left: "35%", zIndex: 20 }}
						>
							<SabiasQue
								icono={sabiasQue[1].icono}
								texto={sabiasQue[1].texto}
							/>
						</Box>
					)}
				</Box>

				{/* River of Life */}
				<Box
					data-block-id="text-5"
					sx={{
						display: "flex",
						gap: 2,
						alignItems: "flex-start",
						position: "relative",
					}}
				>
					<Box sx={{ width: "70%" }}>
						{block3Title && (
							<Box component="h3" sx={estiloH3}>
								{block3Title}
							</Box>
						)}
						{block3Body && (
							<Box component="p" sx={estiloP}>
								{block3Body}
							</Box>
						)}
					</Box>
					{img3 && (
						<Box
							component="img"
							src={img3}
							alt=""
							sx={{
								width: "40%",
								height: 100,
								borderRadius: "12px",
								objectFit: "cover",
							}}
						/>
					)}
					{sabiasQue[2] && (
						<Box
							sx={{
								position: "absolute",
								bottom: isSmallScreen ? -10 : 0,
								left: isSmallScreen ? "53%" : "33%",
								zIndex: 20,
							}}
						>
							<SabiasQue
								icono={sabiasQue[2].icono}
								texto={sabiasQue[2].texto}
							/>
						</Box>
					)}
				</Box>

				{(llegarTitle || llegarList) && (
					<Box
						data-block-id="text-6"
						sx={{
							backgroundColor: "#dee7e3",
							border: "3px solid #2E7D5B",
							borderRadius: "12px",
							padding: "16px 20px",
							fontSize: 12,
							color: "#333",
							marginBottom: isSmallScreen ? 2 : 0,
						}}
					>
						{llegarTitle && (
							<Box
								component="h4"
								sx={{
									margin: 0,
									marginBottom: 1,
									fontSize: 13,
									fontWeight: 700,
									color: "#2e7d5b",
									textTransform: "uppercase",
								}}
							>
								{llegarTitle}
							</Box>
						)}
						{llegarList && (
							<Box
								component="ul"
								sx={{ paddingLeft: 2.5, margin: 0, lineHeight: 1.5 }}
								dangerouslySetInnerHTML={{ __html: llegarList }}
							/>
						)}
					</Box>
				)}
			</Box>
		</Box>
	);
};

Template223.thumbnail = "/images/template-1.png";
export default Template223;
